import { TargetTypes } from 'entities/Config'
import { getGtmContainerId } from 'utils/getTenantSpecificValues'
import type {
  TargetType,
  TargetingDatalayer,
  TargetingQuerystring,
} from 'entities/Config'

const matchTargeting = (targeting: Array<TargetType>) => {
  const gtmContainerId = getGtmContainerId()
  return targeting.some((target: TargetType) => {
    if (target.type === TargetTypes.datalayer && window?.dataLayer?.length) {
      const dataLayerValue = window?.google_tag_manager?.[
        gtmContainerId
      ]?.dataLayer?.get((target as TargetingDatalayer).path)

      return dataLayerValue === target.value
    }

    if (target.type === TargetTypes.querystring) {
      const params = new URLSearchParams(window.location.search)

      return params.get((target as TargetingQuerystring).key) === target.value
    }

    if (target.type === TargetTypes.pathname) {
      return target.value === window.location.pathname
    }

    return false
  })
}

export default matchTargeting
